import Constants from 'Constants'

export const WORK_ORDERS_REVIEW_TABS = {
  NOT_READY: 'Not ready',
  READY: 'Ready',
  INVOICED: 'Invoiced',
}

// The default range spans 3 days in dev mode and 7 in prod.
export const DATE_RANGE_INITIAL_LIMIT = Constants.DEV_MODE ? 2 : 6
